export default __webpack_public_path__ + "static/media/shape-bg2.4b7c783f.png";